































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import ITrash from '@/components/icons/ITrash.vue'
import IEdit from '@/components/icons/IEdit.vue'
import IBarcode from '@/components/icons/IBarcode.vue'
import Tooltip from '@/components/UI/Tooltip.vue';
import {namespace} from "vuex-class"
import TableComponent from "@/components/UI/TableComponent.vue";
import {urlWithContour} from "@/helpers/currentContour";
import Modal from '@/components/UI/Modal.vue';
import VueQrcode from 'vue-qrcode'
const roistat = namespace('roistat')
const profile = namespace("profile")
const locale = namespace('locale')
const events = namespace('event')

@Component({
  name: 'c-list',

  components: {
    Modal,
    VueQrcode,
    'i-trash': ITrash,
    'i-edit': IEdit,
    'i-barcode': IBarcode,
    Tooltip,
    TableComponent
  },
})
export default class List extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @locale.Getter('getLocale') protected getLocale:any
  @events.Getter('eventId') protected eventId:any
  @events.Getter('shows') protected shows:any

  @Prop(Array) items!: any[]
  @Prop({type: [Boolean], default: false}) protected loading!: boolean

  get headers() {
    return [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'barcode',
        type: 'barcode',
        width: '70',
        action: 'openBarcode',
        itemTooltip: this.$t('tooltip.badge_standman')
      },
      {
        text: '',
        sortable: false,
        value: 'vendorCode',
        type: 'vendorCode',
        width: '70',
        action: 'openVendorCode',
        itemTooltip: this.$t('tooltip.badge_standman')
      },
      { text: this.$t('profile.standman.name'), value: 'first', sortable: false, width: '144' },
      { text: this.$t('profile.standman.last_name'), value: 'last', sortable: false, width: '246' },
      { text: this.$t('profile.standman.position'), value: 'position', sortable: false, },
      { text: '', value: 'edit', sortable: false, width: '56', type: 'icon', action: 'openDialog', itemTooltip: this.$t('tooltip.edit_standman') },
      { text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deleteStandist', itemTooltip: this.$t('tooltip.delete_standman') },
    ]
  }

  clickTable(item:any, action:any) {
    this[action as keyof List](item)
  }

  deleteStandist(item:any) {
    this.$emit('deleteStandist', item)
  }

  openDialog(item:any) {
    this.$emit('openDialog', item)
  }

  currentProductLink:string = ''
  currentProductTitle:string = ''
  qrDlgState:boolean = false

  openVendorCode (item:any): void {
    this.currentProductLink = `${urlWithContour()}/e/${this.eventId}/b/${ item.barcode }`
    this.currentProductTitle = item.first + ' ' + item.last
    this.qrDlgState = true
    let params = [
      {
        "name": "“Продукция”: Действие “Показать QR”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }
  openBarcode(item:any) {
    this.$emit('openBarcodeDlg', item)
    let url = document.location.href
    let params = [
      {
        "name": url.includes('profile') ? "“Профиль”: Действие “Показать штрих” в блоке Бейдж" : "“Стендисты”: Действие “Показать штрих”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }
}
